export default {
    threat: 'Threat',
    threatMenu: 'Threat catalog',
    threats: 'Threats',
    newThreat: 'Add new threat',
    actor: 'Actor',
    actorPlaceHolder: 'Select an effect',
    noActor: 'Actor not found',
    noActors: 'Actors not found',
    reason: 'Reason',
    reasonPlaceHolder: 'Select a Reason',
    noReason: 'Reason not found',
    noReasons: 'Reasons not found',
    example: 'Example',
    code: 'Code',
    codePlaceHolder: 'Threat Code',
    createThreat: 'Create threat',
    getThreatsError: 'An error occurred while fetching threats: ',
    createThreatError: 'An error occurred while creating threat: ',
    createThreatSuccess: 'Threat created successfully',
    deleteThreatError: 'It has not been possible to delete the threat because it has related assets or vulnerabilities.',
    noRegisteredThreats: 'You don\'t have any registered threats yet',
    importThreatsFromCsv: 'You can import threats from a CSV file.',
    threatsGuide: 'The following is an inventory of threats that can impact systems, you can add new ones, you can associate them with assets within scope and vulnerabilities you can exploit.',
    catalogThreats: 'Threat Catalog',
    saveThreat: 'Save Threat',
    threatsGuideSettings: 'Manage the threat catalog and add new entries within this module.',

};
